import { HistoryItemPeriod, getHistoryItemPeriodValue } from '../../../../interfaces/historyItem';
import { BoxQuotaData } from '../../../../model/box.quote.data';
import { ITIWizardResultData } from '../../interfaces/scanner.interfaces';



export function computeTIScan(data: anychart.data.Table,historyData:number[][],symbol:string, period:HistoryItemPeriod, box?:BoxQuotaData):ITIWizardResultData {


   
    console.log("computeTIScan" + symbol);
    let volatilityV =  computeVolatilityScanner(data, historyData,period)
   
    let momentum = computeMomentumScanner(data, historyData,period);

    let buyAndSellScanner = computeBuyAndSellScanner(data)


    //console.log([volatility , momentum , buyAndSellScanner]);


    return {
        volatility:volatilityV,
        momentum:momentum,
        buyandsell:buyAndSellScanner
    }


  
}

export const atrPeriod = 14;
export function computeVolatilityScanner(data: anychart.data.Table, historyData:number[][], period:HistoryItemPeriod) {
    var atrCtx: anychart.math.atr.Context = anychart.math.atr.initContext(atrPeriod);

    //console.log("historyData");
   // console.log(historyData)
    //return;
    let endDate = historyData[historyData.length-1][0];
    var mapping = data.mapAs();

    mapping.addField("dt", 0); // key - DateTime
    mapping.addField("open", 1);
    mapping.addField("high", 2);
    mapping.addField("low", 3);
    mapping.addField("close", 4);
    mapping.addField("volume", 5);

   // if(startDate==-2)
   // {
        let startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
   // }
    

    var sel =
        startDate > 0 && endDate
            ? mapping.createSelectable().select(startDate, endDate)
            : mapping.createSelectable().selectAll();
    var iterVolumeMa = sel.getIterator();

    let Atr: number[] = [];
    let i= 0;
    while (iterVolumeMa.advance()) {
       
        //  var dt = iterBlack.get("dt");
        var c = iterVolumeMa.get("close");
        var h = iterVolumeMa.get("high");
        var l = iterVolumeMa.get("low");

        if(i==0)
        {
         //   console.log(c,h,l,period,startDate, endDate);
            i++;
        }

        var black = anychart.math.atr.calculate(atrCtx, c, h, l);
        if (!isNaN(black)) {
            Atr.push(black);
        }
    }

   



    let max = Math.max(...Atr);
    let last = Atr[Atr.length - 1];

    let scaleVal = (150 * last) / max;

    return scaleVal;
}


export function _computeBuyAndSellScanner(data:number[][], box?:BoxQuotaData)
{
        if(!box) return;

        let _lastPiontBS = data[data.length - 1];
        let _prevHistoryPiontBS = data[data.length - 2];
        let _prevHistoryPiontBS_temp = data[data.length - 3];

        let bid = box.Bid;
        let prevBid = data[data.length - 1][4];


    

        let bAs = isNaN(_prevHistoryPiontBS[4])
                ? 0
                : // : Math.ceil(Number((this._prevHistoryPiontM1[4] - this.box.Bid) / Math.pow(10, -(this.box.Decimal-1))));
            //    Math.ceil(
                    Number((prevBid - bid) / bid) /
                        Math.pow(10, -(box.Decimal - 1))


            //    );
        if(bAs<-5000)
        {
        //   debugger
        }
        return bAs;


}




export function computeBuyAndSellScanner(data: anychart.data.Table, endDate?: number, period?: HistoryItemPeriod, startDate: number = -2)
{

    let smachWizardPeriod = 89;


    var lowCtx: anychart.math.sma.Context = anychart.math.sma.initContext(smachWizardPeriod);
    var highCtx: anychart.math.sma.Context = anychart.math.sma.initContext(smachWizardPeriod);
  
    var mapping = data.mapAs();
    mapping.addField("dt", 0);
    mapping.addField("high", 2);
    mapping.addField("low", 3);
    mapping.addField("close", 4);
    
   
     var sel = mapping.createSelectable().selectAll()
     var iterlong = sel.getIterator();


    if(startDate==-2)
    {
        startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 200 : -1;
    }
    
// console.log([startDate, endDate])
//     var sel =
//         startDate > 0 && endDate
//             ? mapping.createSelectable().select(startDate, endDate)
//             : mapping.createSelectable().selectAll();
//     var iterVolumeMa = sel.getIterator();


   // var iterlong = sel.getIterator();










    let longValues:any = [];
    while (iterlong.advance()) {
        var dt = iterlong.get("dt");
        var h = iterlong.get("high");
        var l = iterlong.get("low");
        var c = iterlong.get("close");
        

        var hv = anychart.math.sma.calculate(highCtx, h);
        var lv = anychart.math.sma.calculate(lowCtx, l);

        longValues.push({
            date: dt,
            hvalue: hv,
            lvalue: lv,
            dataVal: c,
            high:h,
            low:l,
        });
    }



  //  console.log(longValues);
   
    if(longValues.length>0)
    {

   
        let lastVal = longValues[longValues.length-1];
        let diff =  (lastVal.hvalue - lastVal.lvalue);
        let range = Math.abs(diff*5);

        let computeCenter = lastVal.lvalue + diff/2

        let factor = 0;
        let perc = 0;

        if(computeCenter>lastVal.dataVal)
        {
            factor = -1;

        //  let relLength = Math.abs(computeCenter - range)
            let relVal = Math.abs(computeCenter - lastVal.dataVal)
            perc = 100*(relVal/range);

        // perc = 100 * (Math.abs(lastVal.dataVal - (computeCenter - range))/range)
        }
        else
        {

        //   let relLength = Math.abs(computeCenter - range)
            let relVal = Math.abs(lastVal.dataVal - computeCenter)
            perc = 100*(relVal/range);

            factor = 1;
        //   perc = 100 * (Math.abs((computeCenter + range) - lastVal.dataVal)/range);
        }

        return factor*perc;

        //console.log([factor,perc,lastVal])
    }
    return 0;
}



















export function computeMomentumScanner(
    data: anychart.data.Table, historyData:number[][], period:HistoryItemPeriod
   
){
        var d: number = 0; // last value from close
        var highValue: number = -1000000;
        var lowValue: number = 1000000;
        var res: number = 0;




        var mapping = data.mapAs();
        mapping.addField("close", 4);
   
        let endDate = historyData[historyData.length-1][0];
        
        let startDate = endDate && period ? endDate - getHistoryItemPeriodValue(period) * 100 : -1;
       
        var sel =
            startDate > 0 && endDate
                ? mapping.createSelectable().select(startDate, endDate)
                : mapping.createSelectable().selectAll();
        var iter = sel.getIterator();

        var deviotion: number[] = [];
        var prevValue = -999999;

        while (iter.advance()) {
            var c = iter.get("close");
           
            if (prevValue == -999999) {
                deviotion.push(0);
            } else {
                if (c != prevValue) {
                    deviotion.push(100 * (prevValue != 0 ? (c - prevValue) / prevValue : 0));
                }
            }

            prevValue = c;
        }

        d = deviotion.length > 0 ? deviotion[deviotion.length - 1] : 0;
        highValue = Math.max.apply(null, deviotion);
        lowValue = Math.min.apply(null, deviotion);
        var highDeviation: number = Math.abs(highValue);
        var lowDeviation: number = Math.abs(lowValue);
        d = d * 1.5; // all are currencies
        highDeviation = highDeviation > 5 ? 5 : highDeviation;
        lowDeviation = lowDeviation > 5 ? 5 : lowDeviation;
        d = d > 0 ? d / highDeviation : d / lowDeviation;

        d = d < -1 ? -1 : d;
        d = d > 1 ? 1 : d;
        d = d * 100;
        d = Math.ceil(d);

        
        
    return d;
}

export function NumberIsBetween(n1:number, n2:number, n3:number):number | boolean {
	return isNaN(n1) || isNaN(n2) || isNaN(n3) ? NaN : n1 >= Math.min(n2, n3) && n1 <= Math.max(n2, n3);
};